import axios from 'axios';
import {
    ADD_VERIFICATION_PROCESS_FAIL,
    ADD_VERIFICATION_PROCESS_REQUEST,
    ADD_VERIFICATION_PROCESS_SUCCESS,
    GET_VERIFICATION_PROCESSES_FAIL,
    GET_VERIFICATION_PROCESSES_REQUEST,
    GET_VERIFICATION_PROCESSES_SUCCESS,
    UPDATE_VERIFICATION_PROCESS_FAIL,
    UPDATE_VERIFICATION_PROCESS_REQUEST,
    UPDATE_VERIFICATION_PROCESS_SUCCESS,
    DELETE_VERIFICATION_PROCESS_FAIL,
    DELETE_VERIFICATION_PROCESS_REQUEST,
    DELETE_VERIFICATION_PROCESS_SUCCESS,
} from '../constants/verificationProcessConstants';

const baseUrl = process.env.REACT_APP_API_URL;

export const addVerificationProcess = (process) => async (dispatch, getState) => {
    try {
        dispatch({
            type: ADD_VERIFICATION_PROCESS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/verification-processes/add-verification-process`,
            { process },
            config
        );

        dispatch({
            type: ADD_VERIFICATION_PROCESS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: ADD_VERIFICATION_PROCESS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getVerificationProcesses = (page = 1, limit = 10, search = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_VERIFICATION_PROCESSES_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/verification-processes?page=${page}&limit=${limit}&search=${search}`,
            config
        );

        dispatch({
            type: GET_VERIFICATION_PROCESSES_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_VERIFICATION_PROCESSES_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const updateVerificationProcess = (id, process) => async (dispatch, getState) => {
    try {
        dispatch({
            type: UPDATE_VERIFICATION_PROCESS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.put(
            `${baseUrl}/verification-processes/${id}`,
            { process },
            config
        );

        dispatch({
            type: UPDATE_VERIFICATION_PROCESS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: UPDATE_VERIFICATION_PROCESS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteVerificationProcess = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: DELETE_VERIFICATION_PROCESS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.delete(`${baseUrl}/verification-processes/${id}`, config);

        dispatch({
            type: DELETE_VERIFICATION_PROCESS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: DELETE_VERIFICATION_PROCESS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};


export const getMyVerificationProcesses = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_VERIFICATION_PROCESSES_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        // This will fetch verification processes assigned to the current user
        // You might need to create a separate endpoint for this in your backend
        const { data } = await axios.get(
            `${baseUrl}/verification-processes/my-processes`,
            config
        );

        dispatch({
            type: GET_VERIFICATION_PROCESSES_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_VERIFICATION_PROCESSES_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};